
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notificationtemplate/create",
      function () {
        return require("private-next-pages/notificationtemplate/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notificationtemplate/create"])
      });
    }
  